var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D85B46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.3333C13.3333 11.7 13.0333 12 12.6667 12H6.66667C6.3 12 6 11.7 6 11.3333C6 10.9667 6.3 10.6667 6.66667 10.6667H12.6667C13.0333 10.6667 13.3333 10.9667 13.3333 11.3333ZM6 8.66667C6 9.03333 6.3 9.33333 6.66667 9.33333H12.6667C13.0333 9.33333 13.3333 9.03333 13.3333 8.66667C13.3333 8.3 13.0333 8 12.6667 8H6.66667C6.3 8 6 8.3 6 8.66667ZM10.6667 14C10.6667 13.6333 10.3667 13.3333 10 13.3333H6.66667C6.3 13.3333 6 13.6333 6 14C6 14.3667 6.3 14.6667 6.66667 14.6667H10C10.3667 14.6667 10.6667 14.3667 10.6667 14ZM16.0067 12.58L16.48 12.1067C16.5417 12.0449 16.6149 11.9958 16.6956 11.9624C16.7762 11.9289 16.8627 11.9117 16.95 11.9117C17.0373 11.9117 17.1238 11.9289 17.2044 11.9624C17.2851 11.9958 17.3583 12.0449 17.42 12.1067L17.8933 12.58C18.1533 12.84 18.1533 13.26 17.8933 13.52L17.42 13.9933L16.0067 12.58ZM15.5333 13.0533L12.0933 16.4933C12.0333 16.5533 12 16.6333 12 16.7267V17.6667C12 17.8533 12.1467 18 12.3333 18H13.2733C13.36 18 13.4467 17.9667 13.5067 17.9L16.9467 14.46L15.5333 13.0533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/icon_note.3245006ea48952149602b99d85c15614.svg";
export { ForwardRef as ReactComponent };